import React from 'react';
import PropTypes from 'prop-types';
import Incident from './incident';

class IncidentHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  _toggleIncidents() {
    this.setState({ expanded: !this.state.expanded });
  }

  _buttonText() {
    if (this.state.expanded) {
      return <span>- Collapse Incidents</span>;
    } else {
      return (
        <span>
          <var>+ Show All</var> <var>{this.props.incidents.length}</var>{' '}
          <var>Incidents</var>
        </span>
      );
    }
  }

  _displayToggler() {
    return (
      <div
        className="expand-incidents font-small border-color color-secondary"
        onClick={this._toggleIncidents.bind(this)}
      >
        {this._buttonText()}
      </div>
    );
  }

  _renderIncidents() {
    if (this.state.expanded) {
      return this.props.incidents.map(incident => (
        <Incident key={incident.code} incident={incident} />
      ));
    } else {
      return this.props.incidents
        .slice(0, 3)
        .map(incident => <Incident key={incident.code} incident={incident} />);
    }
  }

  render() {
    return (
      <div className="incident-history">
        <div className="incident-list">
          {this.props.incidents.length === 0 ? (
            <span className="small">No incidents reported for this month.</span>
          ) : (
            this._renderIncidents()
          )}
        </div>
        {this.props.incidents.length > 3 ? this._displayToggler() : null}
      </div>
    );
  }
}

IncidentHistory.propTypes = {
  incidents: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default IncidentHistory;
